import { Component, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widget-base/widget-base.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-widget-headline',
    imports: [CommonModule],
    templateUrl: './widget-headline.component.html',
    styleUrls: ['./widget-headline-base.component.scss']
})
export class WidgetHeadlineBaseComponent extends WidgetBaseComponent implements OnInit {
  public message: string | undefined;
  public size: string | undefined;
  public color: string | undefined;
  public id: string | undefined;
  public cssClass: string | undefined;
  public marginTop: string | undefined;
  public marginRight: string | undefined;
  public marginBottom: string | undefined;
  public marginLeft: string | undefined;

  public ngOnInit(): void {
    this.message = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Message") == 0)?.value;
    let sizeValue = this.widget?.contentWidgetAttributeList?.find(s => s.key?.localeCompare("Size") == 0)?.value;
    this.color = this.widget?.contentWidgetAttributeList?.find(s => s.key?.localeCompare("Color") == 0)?.value;
    this.size = "fs-" + sizeValue;
    this.id = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Id") == 0)?.value;
    if (this.id && this.id.includes(' ')) {
      this.id = this.id.split(' ')[0];
    }
    this.cssClass = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("CssClass") == 0)?.value;
    this.marginTop = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginTop") == 0)?.value;
    this.marginRight = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginRight") == 0)?.value;
    this.marginBottom = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginBottom") == 0)?.value;
    this.marginLeft = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginLeft") == 0)?.value;
  }

}
